<template>
    <div>
        <transition name="fade">
            <div v-if="isOpen" class="sidenav-overlay" @click.prevent="close()"></div>
        </transition>


        <nav class="sidenav" :class="{'open':isOpen}">
            <ul>
                <li class="nav-item"><a href="#" @click.prevent="close()" class="nav-link close-link">x close</a></li>
                <li>
                    <form class="form-inline mr-auto mt-2 mt-lg-0">
                        <search-field/>
                    </form>
                </li>
                <component :is="a.subs?'li':'router-link'"
                        v-for="a in navigation"
                        :to="{name:a.name}"
                        :key="a.name"
                        tag="li"
                        class="nav-item"
                        activeClass="active"
                        @click.native="closeByLink()">
                    <a v-if="!a.component && !a.subs" class="nav-link">
                      <span class="icn"><fa-icon :icon="a.icon"/></span>
                      {{a.label}}
                    </a>
                    <div v-if="!a.component && a.subs">
                      <router-link v-for="sub in a.subs"
                                   :to="{name: sub.name}"
                                   class="nav-link"
                                   :key="sub.name"
                                   activeClass="active"
                                   @click.native="closeByLink()"
                      ><span class="icn"><fa-icon :icon="sub.icon"/></span> {{sub.label}}</router-link>
                    </div>
                  <component v-if="a.component" :is="a.component"><span class="icn"><fa-icon :icon="a.icon"/></span> {{a.label}}</component>
                </component>

                <router-link v-if="!isLoggedIn" to="/login" tag="li" class="mav-item" activeClass="active"><a class="nav-link">Login</a></router-link>
                <li v-if="isLoggedIn" class="mav-item">
                  <a class="nav-link" href="#" @click.prevent="logout">
                    <span class="icn"><fa-icon :icon="['fal', 'power-off']"/></span>
                    Logout</a></li>

            </ul>
        </nav>

    </div>
</template>

<script>
    import SearchField from '../ui/SearchField.vue'
    import nav from '../../store/Navigation'

    export default {
        name: '',
        data() {
            return {
                navigation: nav.main,
                isOpen: false
            }
        },
        computed: {
            isLoggedIn(){
                return this.$store.state.user.isLoggedIn;
            }
        },
        created() {
            this.$bus.$on('sidebar.toggle', (str)=>{
                this.toggle()
            });
            this.$bus.$on('sidebar.open', (str)=>{
                this.isOpen = true;
                document.body.classList.add('sidebar-open')
                this.$bus.$emit('modal.open', 'sideNav')
            });
            this.$bus.$on('sidebar.close', (str)=>{
                this.isOpen = false;
                document.body.classList.remove('sidebar-open');
                this.$bus.$emit('modal.close', 'sideNav')
            });
        },
        methods: {
            toggle(){
                if(this.isOpen){
                    this.close();
                } else {
                    this.open();
                }
            },
            logout(){
                this.$store.commit('user/unsetToken');
                this.$router.push({name: 'Login'});
                this.close();
            },
            open(){
                this.$bus.$emit('sidebar.open');
            },
            close(){
                this.$bus.$emit('sidebar.close');
            },
            closeByLink(){
                setTimeout(this.close,200);
            },

        },
        components:{
            SearchField
        }
    }
</script>

<style lang="sass">

    @import '../../assets/sass/vars.scss'
    $navWidth: 230px

    .sidenav
        padding-top: 20px
        height: 100%
        width: $navWidth
        position: fixed
        top: 0
        right: -$navWidth
        bottom: 0
        z-index: $z-siedeNav
        background-color: #262323
        transition: all .2s linear
        box-shadow: inset 4px 0 4px rgba(0,0,0,.2)

        ul
            padding-left: 0
            li
                list-style-type: none
                padding-left: 0

        &.open
            right: 0px

        form
            padding: .5rem 1rem

        .close-link
            color: #CCC
            font-size: .8rem
          
        .icn
          display: inline-block
          width: 30px
          color: #FFF

        .active .icn
          color: $colorPrimary

    .sidenav-overlay
        position: fixed
        top: 0
        left: 0
        right: 0
        bottom: 0
        background-color: rgba(0,0,0,.7)
        z-index: 1

    body .main
        //transform: translate3d(0, 0, 0)

    body.sidebar-open .main
        transform: translate3d(-230px, 0, 0)
        transition: all .2s linear

    .fade-enter-active, .fade-leave-active
        transition: opacity .2s

    .fade-enter, .fade-leave-to
        opacity: 0

    
</style>



// WEBPACK FOOTER //
// src/components/layout/SideNav.vue